import styled from 'styled-components'

import { Skeleton } from '@blade/ui-kit'

type PairListItemProps = {
  size?: number
  quoteSize?: number
}

export const PairIconSkeleton: React.FC<PairListItemProps> = ({
  size = 32,
}) => {
  return (
    <Root>
      <Skeleton variant="rectangle" height={size} width={size} />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  align-items: center;
  justify-content: center;
  padding-right: 4px;
  position: relative;
`
